import Form from 'vform';
import axios from '@/libs/axios'

  Form.prototype.submit = function submit(method, url, config = {}) {
    this.startProcessing();

    const data = method === 'get'
      ? { params: this.data() }
      : this.data();

    return new Promise((resolve, reject) => {
      axios.request({
        url: this.route(url), method, data, ...config,
      })
        .then(response => {
          this.finishProcessing();

          resolve(response);
        })
        .catch(error => {
          this.busy = false;

          if (error.response) {
            this.errors.set(this.extractErrors(error.response), undefined);
          }

          reject(error);
        });
    });
  };

export default Form
